import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const readMessageFunc = createAsyncThunk(
  "contacts/read-message",
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await api.put(`dashboard/contacts/${id}`, payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const readMessageSlicer = createSlice({
  name: "contacts/read-message",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(readMessageFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    });
    builder.addCase(readMessageFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.apiErrors = action.payload?.errors || {};
    });
    builder.addCase(readMessageFunc.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.successMessage = action.payload?.message || "";
    });
  },
});

export default readMessageSlicer.reducer;
